<template>
  <BreadCrumb PageTitle="Modifier Produit" />
  <EditProduct :id="id"  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditProduct from "../../components/Stock/EditProduct.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditProductPage",
  components: {
    BreadCrumb,
    EditProduct,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id;  // <-- get the id
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }


    return { id };
}
});
</script>